export const DESCARTAR_LABEL = "Descartar";
export const SALVAR_LABEL = "Salvar";
export const SOLICITAR_ALTERACAO_LABEL = "Solicitar alteração";
export const CANCELAR_SOLICITACAO_LABEL = "Cancelar solicitação";
export const EM_APROVACAO_TAG = "Em aprovação";
/** Figma 16150:336215. */
export const FAIXA_APROVACAO = (fel: string, vigente: string) =>
  `Obra no ${fel}: a alteração vai para aprovação. Até lá, vale a cotação de ${vigente}.`;
/** Figma 17167:476684. */
export const SOLICITACAO_TEXTO = (
  solicitada: string,
  variacao: string | null,
  data: string,
  vigente: string,
) =>
  `Solicitada: ${[solicitada, variacao, data].filter(Boolean).join(" · ")}. Até a aprovação, vale ${vigente}.`;
export const SOLICITACAO_CANCELADA_MESSAGE = "Solicitação de alteração da cotação cancelada.";
export const MOEDA_PREFIXO = (moeda: string) => `${moeda} = R$`;
export const CAMPO_LABEL = "Cotação (R$)";
export const RECALCULA_NOTA = "Recalcula todos os escopos.";
export const REFERENCIA_TEXTO = (competencia: string, valor: string) =>
  `Última registrada (${competencia}): ${valor}`;
export const SEM_REFERENCIA = "Sem cotação registrada na tabela de moedas.";
export const COTACAO_OBRIGATORIA = "Informe a cotação.";
export const COTACAO_MAIOR_QUE_ZERO = "Informe uma cotação maior que zero.";
export const COTACAO_ALTERADA_MESSAGE =
  "Cotação da Obra alterada. Os escopos macro foram recalculados.";
export const REFERENCIA_ERRO = "Não foi possível consultar a última cotação registrada.";
export const REFERENCIA_PERMISSAO =
  "Você não tem permissão para consultar a última cotação registrada.";
